import DailyBreakdownTable from './DailyBreakdownTable'
import PayPeriod from './PayPeriod'

export default {
	PayPeriod,
	DailyBreakdownTable,
}
